<template>
	<div class="control-group" :class="{filled: selected && selected.length > 0, active: focused, error: errors && errors.length > 0, disabled: disabled}">
		<div class="control-holder">
			<label v-if="label" @click="open()" v-html="label">{{ label }}<span v-if="required">*</span></label>
			<div class="input" :class="{'has-append': appendIcon}">
				<div class="input-holder">
					<v-multiselect 
						v-model="selected"
						:disabled="disabled"
						:options="options" 
						:multiple="true" 
						:label="optionText" 
						:track-by="optionValue" 
						placeholder=""
						@open="focused = true"
						@close="focused = false"
						@search-change="$emit('search', $event)"
						ref="input"
					></v-multiselect>
			    </div>
		    	<span v-if="appendIcon" @click.prevent="$emit('click:append')" class="append-icon"><i class="material-icons">{{ appendIcon }}</i></span>
		    </div>
		</div>
        <transition name="slide-down">
            <div class="error-text" v-if="errors && errors.length > 0">
                <div v-for="error in errors">{{ error }}</div>
            </div>
        </transition>
    </div>
</template>

<script>
	export default {
		props: ['value', 'label', 'errors', 'required', 'placeholder', 'disabled', 'appendIcon', 'autocomplete', 'readonly', 'options', 'optionText', 'optionValue'],
		data() {
			return {
				selected: this.value,
				focused: false
			}
		},
		methods: {
			open() {
				if(this.disabled) {
					return;
				}
				this.$refs.input.toggle();
			}
		},
		watch: {
			selected() {
				this.$emit('input', this.selected);
			},
			value() {
				this.selected = this.value;
			}
		}
	}
</script>